import {Component, Input, OnInit} from '@angular/core';
import { Coordinate } from '../../../shared/model/coordinate';
import { CoordinateAttributeName } from '../../../shared/model/coordinate-attribute-name';
import * as moment from 'moment/moment';
import { DiagnosisWebSocketService } from '../../service/diagnosis-web-socket.service';
import { DiagnosisService } from '../../service/diagnosis.service';

@Component({
  selector: 'tx-coordinates-display',
  templateUrl: './coordinates-display.component.html',
  styleUrls: ['./coordinates-display.component.css']
})
export class CoordinatesDisplayComponent implements OnInit {
  _coordinates: Array<Coordinate>;
  loadingText = 'Carregando...';
  unavailableText = 'Indisponível';
  running = true;
  _vehicle: any;
  _run: boolean;

  constructor(private _diagnosisNotification: DiagnosisWebSocketService,
              private _diagnosisService: DiagnosisService) {
  }

  ngOnInit() {
    if (this._run) {
      this.setEmptyEntities();
      this.getLastHourCoordinates();
      this.observeRestart();
      this.observeVehicle();
    }
  }

  get run() {
    return this._run;
  }

  @Input()
  set run(run) {
    this._run = run;
  }

  get coordinates() {
    return this._coordinates;
  }

  @Input()
  set coordinates(coordinates) {
    this._coordinates = coordinates;
  }

  get vehicle() {
    return this._vehicle;
  }

  @Input()
  set vehicle(vehicle) {
    this._vehicle = vehicle;
  }

  observeVehicle() {
    this._diagnosisNotification.vehicle$
      .subscribe((vehicle) => {
        this._vehicle = vehicle;
        this.getLastHourCoordinates();
        this.setEmptyEntities();
        this.running = true;
      });
  }

  observeRestart() {
    this._diagnosisNotification.restart$
      .subscribe(() => {
        this.getLastHourCoordinates();
        this.setEmptyEntities();
        this.running = true;
      });
  }

  setEmptyEntities() {
    this._coordinates = new Array();
  }

  getHeaders() {
    const headers = new Array();
    Object.keys(CoordinateAttributeName).forEach(header => {
      headers.push(CoordinateAttributeName[header]);
    });
    return headers;
  }

  getAttributes() {
    return Object.keys(CoordinateAttributeName);
  }

  getFormattedDate(date) {
    if (date) {
      return moment(date).format('DD/MM/YYYY HH:mm:ss');
    }
  }

  downloadCoordinates() {
    this._diagnosisService.dowloadCoordinates(this._coordinates);
  }

  getLastHourCoordinates() {
    this._diagnosisService.getLastHourCoordinates(this._vehicle)
      .subscribe(
        (response: any) => {
          this._coordinates = Object.assign(new Array<Coordinate>(), JSON.parse(response._body));
          this.running = false;
        },
        error => this.running = false
      );
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/diagnosis/component/coordinates-display/coordinates-display.component.ts